import { SquarePen } from "lucide-react";
import { useIntl } from "react-intl";

import { successToast } from "../../../../../atoms/toast";
import {
  DataFormToolbarButton,
  DataFormToolbarLayout,
} from "../../../../../data-form";
import { useDataTableContext } from "../../../../context";
import { useDataFormPreferencesContext } from "../../context";
import { useDataTablePreferenceFormMutation } from "../../mutation";
import { DataFormPreferencesToolbarCancelButton } from "./data-form-toolbar-cancel-button";
import { DataFormPreferencesSaveButton } from "./data-form-toolbar-save-button";

export function DataFormPreferenceOverrideButton() {
  const intl = useIntl();
  const { setMode } = useDataFormPreferencesContext();

  return (
    <DataFormToolbarButton
      icon={{ Icon: SquarePen }}
      tooltip={intl.formatMessage({
        id: "data-table.preferences.override",
        defaultMessage: "Přepsat přehled aktuálním nastavením",
      })}
      onClick={() => setMode("override")}
    />
  );
}

export function DataFormPreferenceOverrideAction() {
  const intl = useIntl();

  const { entity, setMode } = useDataFormPreferencesContext();

  const table = useDataTableContext();

  const tableState = table.getState();

  const preferenceObject = {
    columnFilters: tableState.columnFilters,
    columnOrder: tableState.columnOrder,
    columnPinning: tableState.columnPinning,
    columnSizing: tableState.columnSizing,
    columnVisibility: tableState.columnVisibility,
    sorting: tableState.sorting,
  };

  const mutation = useDataTablePreferenceFormMutation();

  if (!entity) {
    return null;
  }

  return (
    <DataFormToolbarLayout>
      <DataFormPreferencesToolbarCancelButton />

      <DataFormPreferencesSaveButton
        isLoading={mutation.isPending}
        onClick={async () => {
          await mutation.mutateAsync({
            type: "update",
            values: {
              ...entity,
              settings: JSON.stringify(preferenceObject),
            },
          });

          setMode("detail");

          successToast(
            intl.formatMessage({
              id: "data-form-preferences.update.sucess.title",
              defaultMessage: "Přehled byl prepsán aktuálním nastavením",
            }),
          );
        }}
      />
    </DataFormToolbarLayout>
  );
}
